// extracted by mini-css-extract-plugin
export default {"input":"AddProductForm_input__geYwS","logo":"AddProductForm_logo__0XRtl"};